export const FieldsetTitle = ({children}) => (
  <div className="flex w-100 border-t border-gray-200 py-4 mt-6">
    <h4 className="flex font-md text-gray-500">{children}</h4>
  </div>
);
